import { GuestLiteModel } from 'api-hooks/guest';
import { colors } from 'baseui/tokens';
import { NavigationRoutes } from 'common/constants';
import { capitalize } from 'common/utils/string';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { ActionButton, HalfSection } from './style';

interface Props {
  guest: GuestLiteModel;
  onDismiss: () => void;
}

export default function GuestCard(props: Props) {
  const { t } = useTranslation();
  const { guest } = props;
  const { navigate } = useNavigation();

  const redirect = () => {
    navigate(NavigationRoutes.GuestsView, {
      id: props.guest.id,
    });
    props.onDismiss();
  };

  const onKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (e) => {
    if (e.key === 'Enter') {
      redirect();
    }
    e.stopPropagation();
  };

  return (
    <CardSection style={{ flexDirection: 'row' }}>
      <HalfSection>
        <Text variant="LabelMedium" $style={$style.wrappingText}>
          {`${capitalize(guest.title)} ${guest.name} - ${guest.alias || ''} (${(
            guest.category || ''
          ).toUpperCase()})`}
        </Text>
        <Text
          variant="LabelSmall"
          $style={{ ...$style.wrappingText, ...$style.informationText }}
        >
          {guest.email}
        </Text>
        <Text
          variant="LabelSmall"
          $style={{
            ...$style.wrappingText,
            ...$style.informationText,
            marginBottom: 0,
          }}
        >
          {guest.phone}
        </Text>
      </HalfSection>
      <HalfSection style={{ alignItems: 'end' }}>
        <ActionButton tabIndex={0} onClick={redirect} onKeyDown={onKeyDown}>
          {t('customer:view_guest')}
        </ActionButton>
      </HalfSection>
    </CardSection>
  );
}

const $style: { [key: string]: StyleObject | any } = {
  wrappingText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginBottom: '8px',
  },
  informationText: {
    color: colors.gray500,
  },
};
